import React, { useEffect, useState } from 'react'
import EligibilityQuestionFarmTruckView from './components/EligibilityQuestionFarmTruckView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const EligibilityQuestionFarmTruck = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    try {
      addToGoogleDataLayer('eligibility-farm-truck', 'Renew your Vehicle Permit', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [])

  return isError ? <Error /> : <EligibilityQuestionFarmTruckView setIsError={setIsError} />
}

export default withTranslation('common')(EligibilityQuestionFarmTruck)